export const APP_ENABLE_FLIPS = 'APP_ENABLE_FLIPS';
export const APP_CLEAR_SURROGATE_KEY = 'APP_CLEAR_SURROGATE_KEY';

export function enableFlips(flips) {
  return {
    type: APP_ENABLE_FLIPS,
    flips
  };
}

export function clearSurrogateKey() {
  return {
    type: APP_CLEAR_SURROGATE_KEY
  };
}
